'use client';

import { type ComponentPropsWithoutRef } from 'react';
import { useSearchContext } from './Search.hooks';
import { useRouter } from 'next/navigation';
import config from '@utils/config';
import { getSearchPathname } from '@utils/url/getSearchPathname';

type SearchFormProps = ComponentPropsWithoutRef<'form'> & {
  onClose: () => void;
};

const SearchForm = ({
  children,
  className,
  onClose,
  ...props
}: SearchFormProps) => {
  const { locale } = config;
  const { formRef } = useSearchContext();
  const router = useRouter();

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    if (formRef?.current) {
      const formData = new FormData(formRef?.current);
      const searchQuery = formData.get('query') as string;
      const trimmedSearchQuery = searchQuery.trim();

      if (trimmedSearchQuery.length === 0) {
        return;
      }

      const newSearchParams = new URLSearchParams(window.location.search);
      const searchPath = getSearchPathname();
      ['category', 'designer', 'brand', 'price', 'sort'].forEach((key) => {
        newSearchParams.delete(key);
      });
      newSearchParams.set('query', searchQuery);
      router.push(searchPath + '?' + newSearchParams.toString());
      onClose();
    }
  };

  return (
    <form
      ref={formRef}
      className={className}
      onSubmit={handleSubmit}
      {...props}>
      {children}
      <input type="hidden" name="locale" value={locale} />
    </form>
  );
};

SearchForm.displayName = 'SearchForm';

export default SearchForm;
